export default __webpack_public_path__ + "static/media/doctor_3.db0eb73b.png";